import {
  Component,
  Injector,
  ViewEncapsulation,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ActivitiesServiceProxy,
  ActivityDaysServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-timesheet-reject-modal',
  templateUrl: './reject.modal.component.html',
  styleUrls: ['./reject.modal.less'],
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()],
})
export class RejectModalComponent extends AppComponentBase implements OnInit {
  saving = false;
  rejectReason = '';

  @Output() onTimesheetReject: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('rejectTimesheetModal', { static: true }) modal: ModalDirective;

  constructor(
    injector: Injector,
    private _activitiesServiceProxy: ActivitiesServiceProxy,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private _notify: NotifyService,
    private _tokenAuth: TokenAuthServiceProxy,
    private _activatedRoute: ActivatedRoute
  ) {
    super(injector);
  }

  ngOnInit(): void {}

  close() {
    this.modal.hide();
  }

  save(rejectReason: string): void {
    this.onTimesheetReject.emit({ reason: rejectReason });
  }
}
